import { useSyncExternalStore } from 'react';
import { trafficStore } from '../stores/traffic.js';

/**
 * Subscribes the component to the live traffic. The connection opens with the first component
 * that asks for it and closes when the last one goes away.
 */
export const useTraffic = () => useSyncExternalStore(trafficStore.subscribe, trafficStore.getSnapshot, trafficStore.getSnapshot);
